<template>
    <VJoyHighlight level="info" display-icon icon="info-circle" class="joy-mt-2" data-testid="search-results-hint">
        <template v-if="isAdmin">
            {{ $t('admin.search.keyword.supply-explorer-hint.text') }}
            <VJoyLink
                :href="supplyExplorerHref"
                :text="$t('admin.search.keyword.supply-explorer-hint.link')"
                data-testid="search-results-hint-supply-explorer-link"
            />
        </template>
        <template v-else>
            {{ $t('search.global-matching.results-circles-hint') }}
        </template>
    </VJoyHighlight>
</template>

<script setup lang="ts">
    import {useRouter} from '@typed-router';
    import {useAuth} from '#imports';
    import {VJoyHighlight, VJoyLink} from '@maltjoy/core-vue';

    const isAdmin = useAuth().hasEnoughPrivilege(['ROLE_ADMIN']);
    const supplyExplorerHref = useRouter().resolve('/s/sourcing-search').href;
</script>
